import { Injectable, EventEmitter } from '@angular/core';
import { Observable } from 'rxjs';
import { webSocket, WebSocketSubject } from 'rxjs/webSocket';
import { retryWhen, delay, tap } from 'rxjs/operators';

export enum WebsocketState {
    disconnected,
    connecting,
    closing,
    connected
}

@Injectable({
    providedIn: 'root'
})
export class WebsocketService {
    private websocket$: WebSocketSubject<any>;
    private messages$: Observable<any>;

    public stateChanged: EventEmitter<WebsocketState> = new EventEmitter<WebsocketState>();


    constructor() {
        this.websocket$ = webSocket({
            url: 'ws://localhost:4444',
            openObserver: {
                next: (value) => {
                    console.log('connetion ok');
                    this.stateChanged.emit(WebsocketState.connected);
                }
            },
            closeObserver: {
                next: (value) => {
                    console.log('connection closed');
                    this.stateChanged.emit(WebsocketState.disconnected);
                }
            },
            closingObserver: {
                next: () => {
                    console.log('connection closing');
                    this.stateChanged.emit(WebsocketState.closing);
                }
            }
        });

        this.messages$ = this.websocket$.pipe(
            retryWhen((error) => error.pipe(
                delay(5000),
                tap((value) => {
                    this.stateChanged.emit(WebsocketState.connecting);
                })
            ))
        );
    }

    public send(data: any) {
        this.websocket$.next(JSON.stringify(data));
    }

    public messages(): Observable<any> {
        return this.messages$;
    }

    public close() {
        this.websocket$.complete();
    }

}
